import { create } from 'zustand';
import { INITIAL_STATE } from './constants';
const useCampaignDetailsStore = create((set) => (Object.assign(Object.assign({}, INITIAL_STATE), { campaignFilter: {
        selectedCampaigns: [],
        setSelectedCampaigns: (campaigns) => {
            set((state) => ({
                campaignFilter: Object.assign(Object.assign({}, state.campaignFilter), { selectedCampaigns: campaigns }),
            }));
        },
    }, candidateFilter: {
        selectedAdGroupCandidates: [],
        setSelectedAdGroupCandidates: (candidates) => {
            set((state) => ({
                candidateFilter: Object.assign(Object.assign({}, state.candidateFilter), { selectedAdGroupCandidates: candidates }),
            }));
        },
    }, dateFilters: {
        setStartDateFrom: (date) => {
            set((state) => ({
                dateFilters: Object.assign(Object.assign({}, state.dateFilters), { startDateFrom: date }),
            }));
        },
        setStartDateTo: (date) => {
            set((state) => ({
                dateFilters: Object.assign(Object.assign({}, state.dateFilters), { startDateTo: date }),
            }));
        },
        setEndDateFrom: (date) => {
            set((state) => ({
                dateFilters: Object.assign(Object.assign({}, state.dateFilters), { endDateFrom: date }),
            }));
        },
        setEndDateTo: (date) => {
            set((state) => ({
                dateFilters: Object.assign(Object.assign({}, state.dateFilters), { endDateTo: date }),
            }));
        },
    }, cityFilter: {
        cityIds: [],
        setCityIds: (ids) => {
            set((state) => ({
                cityFilter: Object.assign(Object.assign({}, state.cityFilter), { cityIds: ids.map(Number) }),
            }));
        },
    }, statusFilter: {
        status: [],
        setStatus: (status) => {
            set((state) => ({
                statusFilter: Object.assign(Object.assign({}, state.statusFilter), { status }),
            }));
        },
    }, createdByFilter: {
        createdBy: '',
        setCreatedBy: (createdBy) => {
            set((state) => ({
                createdByFilter: Object.assign(Object.assign({}, state.createdByFilter), { createdBy }),
            }));
        },
    }, pacingFilter: {
        setPacingEnabled: (pacingEnabled) => {
            set((state) => ({
                pacingFilter: Object.assign(Object.assign({}, state.pacingFilter), { pacingEnabled }),
            }));
        },
    }, clearFilters: () => {
        set((state) => ({
            campaignFilter: Object.assign(Object.assign({}, state.campaignFilter), { selectedCampaigns: [] }),
            candidateFilter: Object.assign(Object.assign({}, state.candidateFilter), { selectedAdGroupCandidates: [] }),
            dateFilters: Object.assign(Object.assign({}, state.dateFilters), { startDateFrom: undefined, startDateTo: undefined, endDateFrom: undefined, endDateTo: undefined }),
            cityFilter: Object.assign(Object.assign({}, state.cityFilter), { cityIds: [] }),
            statusFilter: Object.assign(Object.assign({}, state.statusFilter), { status: [] }),
            createdByFilter: Object.assign(Object.assign({}, state.createdByFilter), { createdBy: '' }),
            pacingFilter: Object.assign(Object.assign({}, state.pacingFilter), { pacingEnabled: undefined }),
        }));
    } })));
export default useCampaignDetailsStore;
